/**
 * Maps backend LongFormTemplate API response to frontend LongFormTemplate type
 * Converts snake_case to camelCase
 */
export function mapLongFormTemplateFromApi(response) {
    return {
        id: response.id,
        name: response.name,
        active: response.active,
        systemType: response.systemType,
        displaySystemType: response.displaySystemType,
        territoryIds: response.territoryIds || []
    };
}
/**
 * Maps backend LongFormTemplateLibrary API response to frontend LongFormTemplateLibrary type
 * Converts snake_case to camelCase
 */
export function mapLongFormTemplateLibraryFromApi(response) {
    return {
        id: response.id,
        name: response.name,
        systemType: response.systemType,
        displaySystemType: response.displaySystemType
    };
}
/**
 * Maps frontend LongFormTemplateFormData to backend UpdateLongFormTemplateRequest
 * Converts camelCase to snake_case for API
 */
export function mapUpdateTemplateToApiRequest(data) {
    const request = {
        long_form_template: {}
    };
    if (data.name !== undefined) {
        request.long_form_template.name = data.name;
    }
    if (data.active !== undefined) {
        request.long_form_template.active = data.active;
    }
    if (data.territoryIds !== undefined) {
        request.long_form_template.territory_ids = data.territoryIds;
    }
    return request;
}
/**
 * Maps library ID to backend ImportLongFormTemplateRequest
 * Converts camelCase to snake_case for API
 */
export function mapImportTemplateToApiRequest(libraryId) {
    return {
        long_form_template_library_id: libraryId
    };
}
